import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';

/**
 * Estado de error fatal (sin datos que mostrar). Reutilizable en cualquier página.
 *
 * Props: error (mensaje), onRetry (opcional), title (opcional), chainName (opcional).
 */
const ErrorState = ({ error, onRetry, title, chainName }) => (
  <div className="flex items-center justify-center min-h-[40vh] px-4 py-10">
    <div className="max-w-md w-full text-center">
      <div className="mx-auto w-12 h-12 rounded-full bg-red-50 flex items-center justify-center mb-4">
        <AlertCircle className="h-6 w-6 text-red-600" />
      </div>
      <h3 className="text-base font-semibold text-gray-900 mb-2">
        {chainName ? `${chainName}: ` : ''}{title || 'Something went wrong'}
      </h3>
      {error && <p className="text-sm text-gray-600 mb-4 break-words">{error}</p>}
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="btn-primary inline-flex items-center gap-2 h-9 px-4 text-sm font-medium"
        >
          <RefreshCw size={16} />
          Retry
        </button>
      )}
    </div>
  </div>
);

export default ErrorState;
